import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../utils/context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, ready } = useAuth();

  if (!ready) return null;

  return isLoggedIn ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
